import { $authHost } from "./index";

export const fetchMyRdpAccess = async () => {
    const { data } = await $authHost.get("api/rdp/me");
    return data;
};

export const createMyRdpRequest = async () => {
    const { data } = await $authHost.post("api/rdp/me/request");
    return data;
};

export const downloadMyRdpFile = async () => {
    const response = await $authHost.get("api/rdp/me/download", {
        responseType: "blob",
    });
    const disposition = response.headers?.["content-disposition"] || "";
    const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);
    return {
        blob: response.data,
        filename: filenameMatch?.[1] || "virtalibry-rdp.rdp",
    };
};

export const fetchRdpAdminOverview = async () => {
    const { data } = await $authHost.get("api/rdp/admin/overview");
    return data;
};

export const createRdpServer = async (payload) => {
    const { data } = await $authHost.post("api/rdp/admin/servers", payload);
    return data;
};

export const updateRdpServer = async (id, payload) => {
    const { data } = await $authHost.put(`api/rdp/admin/servers/${id}`, payload);
    return data;
};

export const createRdpProxy = async (payload) => {
    const { data } = await $authHost.post("api/rdp/admin/proxies", payload);
    return data;
};

export const updateRdpProxy = async (id, payload) => {
    const { data } = await $authHost.put(`api/rdp/admin/proxies/${id}`, payload);
    return data;
};

export const deleteRdpProxy = async (id) => {
    const { data } = await $authHost.delete(`api/rdp/admin/proxies/${id}`);
    return data;
};

export const createRdpManualRequest = async (payload) => {
    const { data } = await $authHost.post("api/rdp/admin/requests", payload);
    return data;
};

export const approveRdpRequest = async (id, payload) => {
    const { data } = await $authHost.post(`api/rdp/admin/requests/${id}/approve`, payload);
    return data;
};

export const rejectRdpRequest = async (id, payload = {}) => {
    const { data } = await $authHost.post(`api/rdp/admin/requests/${id}/reject`, payload);
    return data;
};

export const updateRdpAccount = async (id, payload) => {
    const { data } = await $authHost.put(`api/rdp/admin/accounts/${id}`, payload);
    return data;
};

export const deleteRdpAccount = async (id, payload = {}) => {
    const { data } = await $authHost.delete(`api/rdp/admin/accounts/${id}`, { data: payload });
    return data;
};

export const createRdpAccountJob = async (id, payload) => {
    const { data } = await $authHost.post(`api/rdp/admin/accounts/${id}/jobs`, payload);
    return data;
};

export const runRdpJobDryRun = async (id) => {
    const { data } = await $authHost.post(`api/rdp/admin/jobs/${id}/run-dry-run`);
    return data;
};

export const runRdpJobLive = async (id) => {
    const { data } = await $authHost.post(`api/rdp/admin/jobs/${id}/run-live`);
    return data;
};

export const deleteRdpJob = async (id) => {
    const { data } = await $authHost.delete(`api/rdp/admin/jobs/${id}`);
    return data;
};
